<template>
  <div class="auth-modal-overlay" v-if="visible" @click="closeModal">
    <div class="auth-modal" @click.stop>
      <button class="close-btn" @click="closeModal">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="2"/>
          <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="2"/>
        </svg>
      </button>

      <!-- 登录表单 -->
      <div v-if="mode === 'login'" class="auth-form">
        <h2 class="auth-title">{{ $t('common.login') }}</h2>
        <p class="auth-subtitle">{{ $t('auth.login.subtitle') }}</p>

        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="email">{{ $t('auth.email') }}</label>
            <input
              type="email"
              id="email"
              v-model="loginForm.email"
              :placeholder="$t('auth.emailPlaceholder')"
              required
            >
          </div>

          <div class="form-group">
            <label for="password">{{ $t('auth.password') }}</label>
            <input
              type="password"
              id="password"
              v-model="loginForm.password"
              :placeholder="$t('auth.passwordPlaceholder')"
              required
            >
          </div>

          <div class="form-options">
            <label class="checkbox-label">
              <input type="checkbox" v-model="loginForm.rememberMe">
              <span class="checkmark"></span>
              {{ $t('auth.rememberMe') }}
            </label>
            <a href="#" class="forgot-password">{{ $t('auth.forgotPassword') }}</a>
          </div>

          <button type="submit" class="btn btn-primary btn-full" :disabled="isLoading">
            <span v-if="isLoading">{{ $t('auth.loggingIn') }}</span>
            <span v-else>{{ $t('common.login') }}</span>
          </button>
        </form>

        <div class="auth-footer">
          <p>{{ $t('auth.noAccount') }} <a href="#" @click="switchToRegister">{{ $t('auth.registerNow') }}</a></p>
        </div>

        <div class="auth-divider">
          <span>{{ $t('auth.or') }}</span>
        </div>

        <div class="social-login">
          <button class="btn btn-github">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
            </svg>
            {{ $t('auth.githubLogin') }}
          </button>
          <button class="btn btn-google">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            {{ $t('auth.googleLogin') }}
          </button>
        </div>
      </div>

      <!-- 注册表单 -->
      <div v-else class="auth-form">
        <h2 class="auth-title">{{ $t('common.register') }}</h2>
        <p class="auth-subtitle">{{ $t('auth.register.subtitle') }}</p>

        <form @submit.prevent="handleRegister">
          <div class="form-group">
            <label for="name">{{ $t('auth.username') }}</label>
            <input
              type="text"
              id="name"
              v-model="registerForm.name"
              :placeholder="$t('auth.usernamePlaceholder')"
              required
            >
          </div>

          <div class="form-group">
            <label for="email">{{ $t('auth.email') }}</label>
            <input
              type="email"
              id="email"
              v-model="registerForm.email"
              :placeholder="$t('auth.emailPlaceholder')"
              required
            >
          </div>

          <div class="form-group">
            <label for="password">{{ $t('auth.password') }}</label>
            <input
              type="password"
              id="password"
              v-model="registerForm.password"
              :placeholder="$t('auth.passwordMinLength')"
              required
            >
          </div>

          <div class="form-group">
            <label for="confirmPassword">{{ $t('auth.confirmPassword') }}</label>
            <input
              type="password"
              id="confirmPassword"
              v-model="registerForm.confirmPassword"
              :placeholder="$t('auth.confirmPasswordPlaceholder')"
              required
            >
          </div>

          <div class="form-options">
            <label class="checkbox-label">
              <input type="checkbox" v-model="registerForm.agreeTerms" required>
              <span class="checkmark"></span>
              {{ $t('auth.agreeTerms') }} <a href="#">{{ $t('auth.termsOfService') }}</a> {{ $t('auth.and') }} <a href="#">{{ $t('auth.privacyPolicy') }}</a>
            </label>
          </div>

          <button type="submit" class="btn btn-primary btn-full" :disabled="isLoading">
            <span v-if="isLoading">{{ $t('auth.registering') }}</span>
            <span v-else>{{ $t('common.register') }}</span>
          </button>
        </form>

        <div class="auth-footer">
          <p>{{ $t('auth.hasAccount') }} <a href="#" @click="switchToLogin">{{ $t('auth.loginNow') }}</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialMode: {
      type: String,
      default: 'login'
    }
  },
  data() {
    return {
      mode: this.initialMode,
      isLoading: false,
      loginForm: {
        email: '',
        password: '',
        rememberMe: false
      },
      registerForm: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    switchToLogin() {
      this.mode = 'login'
    },
    switchToRegister() {
      this.mode = 'register'
    },
    async handleLogin() {
      this.isLoading = true
      try {
        // 模拟登录请求
        await new Promise(resolve => setTimeout(resolve, 1500))
        this.$emit('login-success', {
          name: this.loginForm.email.split('@')[0],
          email: this.loginForm.email
        })
        this.closeModal()
      } catch (error) {
        console.error('登录失败:', error)
      } finally {
        this.isLoading = false
      }
    },
    async handleRegister() {
      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        alert(this.$t('auth.passwordMismatch'))
        return
      }

      this.isLoading = true
      try {
        // 模拟注册请求
        await new Promise(resolve => setTimeout(resolve, 2000))
        this.$emit('register-success', {
          name: this.registerForm.name,
          email: this.registerForm.email
        })
        this.closeModal()
      } catch (error) {
        console.error(this.$t('auth.registerFailed'), error)
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.mode = this.initialMode
      }
    }
  }
}
</script>

<style scoped>
.auth-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
  padding: 2rem;
}

.auth-modal {
  background: white;
  border-radius: 1rem;
  width: 100%;
  max-width: 420px;
  max-height: calc(100vh - 4rem);
  overflow-y: auto;
  position: relative;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: modalSlideIn 0.3s ease-out;
  margin: auto;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: #f3f4f6;
  color: #333;
}

.auth-form {
  padding: 2rem;
}

.auth-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  text-align: center;
}

.auth-subtitle {
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group input[type="password"] {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #fafafa;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: #666;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin-right: 0.5rem;
}

.forgot-password {
  color: #667eea;
  text-decoration: none;
  font-size: 0.875rem;
}

.forgot-password:hover {
  text-decoration: underline;
}

.btn {
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  border: none;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.btn-full {
  width: 100%;
}

.auth-footer {
  text-align: center;
  margin-top: 1.5rem;
  color: #666;
}

.auth-footer a {
  color: #667eea;
  text-decoration: none;
}

.auth-footer a:hover {
  text-decoration: underline;
}

.auth-divider {
  text-align: center;
  margin: 1.5rem 0;
  position: relative;
  color: #666;
}

.auth-divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: #e5e7eb;
}

.auth-divider span {
  background: white;
  padding: 0 1rem;
  position: relative;
}

.social-login {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.btn-github {
  background: #333;
  color: white;
  border: 1px solid #333;
}

.btn-github:hover {
  background: #444;
}

.btn-google {
  background: white;
  color: #333;
  border: 1px solid #e5e7eb;
}

.btn-google:hover {
  background: #f9fafb;
}

/* 深色模式 */
:global(.dark-mode) .auth-modal {
  background: #1f2937;
  color: #f3f4f6;
}

:global(.dark-mode) .auth-title {
  color: #f3f4f6;
}

:global(.dark-mode) .form-group label {
  color: #f3f4f6;
}

:global(.dark-mode) .form-group input {
  background: #374151;
  border-color: #4b5563;
  color: #f3f4f6;
}

:global(.dark-mode) .form-group input:focus {
  background: #374151;
  border-color: #667eea;
}

:global(.dark-mode) .auth-divider span {
  background: #1f2937;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .auth-modal-overlay {
    padding: 1rem;
    align-items: flex-start;
    padding-top: 3rem;
  }

  .auth-modal {
    margin-top: 2rem;
    max-height: calc(100vh - 6rem);
  }

  .auth-form {
    padding: 1.5rem;
  }
}

/* 小屏幕设备进一步优化 */
@media (max-height: 600px) {
  .auth-modal-overlay {
    align-items: flex-start;
    padding-top: 1rem;
  }

  .auth-modal {
    margin-top: 0;
    max-height: calc(100vh - 2rem);
  }
}
</style>
